import { useRouter } from "next/router"
import { Routes } from "@blitzjs/next"
import React, { useMemo, useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Button,
} from "@mui/material"
import CopyDialogForm from "./CopyDialogForm"
import { PipelineCopyData } from "./PipelineCopyData"

export default function CopyDialog({
  pipeline,
  open,
  setOpen,
  copyPipelineMutation,
  setSnackbarData,
}) {
  const router = useRouter()
  const [pipelineCopyData, setPipelineCopyData] = useState<Partial<PipelineCopyData>>({})
  const initialValues = useMemo<Partial<PipelineCopyData>>(
    () => ({
      name: pipeline.name,
      geographyId: pipeline.geography.id,
      languageId: pipeline.language.id,
    }),
    [pipeline]
  )

  async function copyPipeline() {
    if (pipelineCopyData.name === "") {
      setSnackbarData({
        type: "error",
        text: "Error: Pipeline name is empty!",
        show: true,
      })

      return
    }

    try {
      const pipelineCopy = await copyPipelineMutation({
        id: pipeline.id,
        ...pipelineCopyData,
      })
      setSnackbarData({ type: "success", text: "Pipeline copied!", show: true })
      setOpen(false)
      await router.push(Routes.EditPipelinePage({ pipelineId: pipelineCopy.id }))
    } catch (err) {
      const errorMessage = err.toString()

      if (errorMessage.includes("Unique constraint failed on the fields")) {
        setSnackbarData({
          type: "error",
          text: "Please choose a different name, geography or language!",
          show: true,
        })
      } else {
        setSnackbarData({ type: "error", text: errorMessage, show: true })
      }
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="md" open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Pipeline copy!</DialogTitle>
        <DialogContent>
          <DialogContentText>Provide a new unique name for this pipeline!</DialogContentText>
          <Box sx={{ mt: 2 }}>
            <CopyDialogForm
              initialValues={initialValues}
              onSubmit={() => {}}
              onChange={setPipelineCopyData}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button disabled={!pipelineCopyData.name?.trim().length} onClick={copyPipeline}>
            Copy
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
